import { render, staticRenderFns } from "./MembershipCard.vue?vue&type=template&id=21324e3a&scoped=true&"
import script from "./MembershipCard.vue?vue&type=script&lang=js&"
export * from "./MembershipCard.vue?vue&type=script&lang=js&"
import style0 from "./MembershipCard.vue?vue&type=style&index=0&id=21324e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21324e3a",
  null
  
)

export default component.exports